import React from "react";
import classes from "pages/Auth/login.module.css";
import Logo from "components/Logo";
import { Link } from "react-router-dom";
import { TextField } from "@mui/material";
function UnlockLogin() {
  return (
    <div className={classes.login}>
      <Logo />
      <p className={classes.title}>Unlock Your Login</p>
      <form className={`${classes.root} ${classes.unlockLogin}`} noValidate autoComplete="off">
          An email has been sent to your email address with your unlock code. Please enter your code in the box below and click "Unlock".
        
        <TextField
          className={classes.inputControl}
        //   id="filled-password-input"
        //   label="Password"
          type="number"
        //   autoComplete="current-password"
        //   variant="filled"
        placeholder="Unlock Code"
        />
        <div className={classes.actions}>
          <Link className={classes.primaryButton} to="/employee">
            Unlock
          </Link>
        </div>
      </form>
      <div className={classes.actions}>
        <Link className={classes.secondaryLink} to="/employee">
          Click here to return to login screen
        </Link>
      </div>
    </div>
  );
}

export default UnlockLogin;
